module.exports = __webpack_public_path__ + "static/media/tram.e1d96b34.jpg";